import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from '../../components/table/table.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { NumberFormatDirective } from '../../utils/number-format.directive';
import { HolidaysComponent } from './holidays/holidays.component';
import { HolidaysEditComponent } from './holidays-edit/holidays-edit.component';

@NgModule({
  declarations: [
    HolidaysComponent,
    HolidaysEditComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatIconModule,
    MatFormFieldModule,
    TableModule,
    MatAccordion,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTableModule,
    NumberFormatDirective,
    MatInputModule
  ],
  exports: [
    HolidaysComponent,
    HolidaysEditComponent
  ]
})
export class HolidaysModule { }
